import laptopImg from '../../assets/service/laptopImageNew.png'
import cctvImg from '../../assets/service/cctvImagenew.png';
import amcImg from '../../assets/service/amcImg.png';
import industrialPc from '../../assets/service/industrialpc.png';
import netwrokingImg from '../../assets/service/netwokingImg.png';
import printerImg from '../../assets/service/printerImg.png';
import accessoriesImg from '../../assets/service/accesorriesImg.png';
import softwareImg from '../../assets/service/softwareimg.png';

const ServiceDetailsData = {
  laptop: {
    title: "Laptop Sales & Services",
    intro: `At Rohan Systems, we offer a wide variety of new laptops, including branded models and customized configurations, alongside fast and reliable laptop repair services. Whether you're a student, a working professional, or a business owner, our laptop solutions are tailored to suit your performance and budget needs.`,
    img:laptopImg,
    sections: [
  {
    heading: "What We Offer",
    points: [
      "We provide the latest laptops from trusted brands such as HP, Dell, Lenovo, Acer, and ASUS, ensuring reliable performance for every need.",
      "Our business laptops come with extended battery life and advanced security features, making them ideal for professionals on the go.",
      "For frequent travelers, we offer lightweight ultrabooks that combine style, portability, and powerful performance.",
      "Gaming enthusiasts can choose from our range of laptops with dedicated graphics, SSD storage, and high-speed processors for a seamless experience.",
      "We also stock versatile touchscreen and 2-in-1 convertible laptops that adapt perfectly to work, study, and entertainment.",
      "To complete your setup, we offer essential laptop bags, cooling pads, chargers, and a wide selection of accessories."
    ],
  },
  {
    heading: "Laptop Services",
    points: [
      "Our expert team handles screen replacements for cracked or damaged displays with genuine, high-quality parts.",
      "We provide quick and reliable keyboard and touchpad repairs to restore smooth typing and navigation.",
      "Upgrade your device with RAM and SSD enhancements to significantly boost speed and performance.",
      "Battery replacements and solutions for charging issues are offered to extend the life of your laptop.",
      "We handle operating system installation and software troubleshooting to keep your device running efficiently.",
      "Professional dust cleaning and fan maintenance services ensure proper cooling and system longevity.",
      "We specialize in repairing water damage and motherboard faults with advanced diagnostic tools.",
      "Secure data backup and recovery solutions are available to safeguard your important files."
    ],
  },
  {
    heading: "Where Laptops Are Used",
    points: [
      "Students and educators rely on laptops for interactive learning, research, and attending online classes.",
      "Freelancers, entrepreneurs, and remote workers use laptops as their primary tool for managing projects and communication.",
      "Small and medium-sized businesses depend on laptops to streamline daily operations, accounting, and team collaboration.",
      "Sales and field teams benefit from laptops for mobile computing, client presentations, and data access on the go.",
      "Content creators and designers prefer high-performance laptops for editing, design, and rendering tasks."
    ],
  },
  {
    heading: "Benefits",
    points: [
      "Modern laptops deliver portability without compromising on performance, making them perfect for professionals and students.",
      "Their compact form factor saves desk space compared to traditional desktops while maintaining functionality.",
      "Built-in wireless connectivity and strong battery backup enable seamless productivity anywhere.",
      "Ideal for travel and hybrid work environments, laptops offer unmatched flexibility and convenience.",
      "They can easily serve dual purposes, handling both work requirements and entertainment needs.",
      "Effortless integration with printers, projectors, and other peripherals enhances usability in offices and homes."
    ],
  },
  {
    heading: "Why Choose Rohan Systems",
    points: [
      "With over 10 years of trusted service, we are a reliable name in IT hardware solutions.",
      "As an authorized dealer for all major laptop brands, we guarantee genuine products at competitive prices.",
      "We offer honest consultations to help you select the best laptop tailored to your specific use-case.",
      "Our support includes both in-store assistance and remote troubleshooting for your convenience.",
      "Doorstep pickup and delivery services are available for repair requests, saving you valuable time.",
      "We provide affordable pricing options, including EMI facilities, to make laptops accessible to everyone.",
      "Every laptop comes with a valid manufacturer warranty and bill, ensuring peace of mind for every purchase."
    ],
  },
  {
    heading: "Add-On Services",
    points: [
      "We provide genuine software licensing, including Windows, Microsoft Office, and leading antivirus programs.",
      "Our team can set up external monitors to boost your productivity with a dual-screen experience.",
      "Choose from a wide range of accessories including laptop bags, ergonomic stands, and wireless keyboards.",
      "We offer seamless data transfer services from your old device to your new laptop for a hassle-free setup.",
      "Protect your investment with our laptop insurance plans and extended warranty options."
    ],
  },
    ],
  },

  cctv: {
    title: "CCTV Solutions",
    intro: `At Rohan Systems, we provide advanced CCTV surveillance solutions designed to keep your home, office, and business premises secure. From basic setups to enterprise-level security, our solutions ensure round-the-clock monitoring with reliability and clarity.`,
    img:cctvImg,
    sections: [
  {
    heading: "What We Offer",
    points: [
      "High-quality CCTV cameras from renowned brands such as Hikvision and CP Plus, ensuring reliable performance and durability.",
      "A variety of camera types including dome, bullet, and PTZ cameras to suit different monitoring needs and environments.",
      "Advanced night vision and motion detection cameras for round-the-clock security and enhanced surveillance capabilities.",
      "Flexible wireless and IP-based CCTV solutions that can be seamlessly integrated into existing systems.",
      "State-of-the-art DVR and NVR recording systems for efficient storage and retrieval of surveillance footage.",
      "Convenient remote monitoring capabilities through mobile applications, enabling real-time access from anywhere.",
      "Comprehensive installation and cabling support, providing a complete end-to-end security solution."
    ],
  },
  {
    heading: "Services",
    points: [
      "Professional CCTV installation and configuration services tailored to your specific security requirements.",
      "Regular maintenance and servicing to ensure the longevity and optimal performance of your security systems.",
      "Expert system upgrades and replacements to keep your surveillance infrastructure up-to-date with the latest technology.",
      "Setup of remote viewing functionality, allowing clients to monitor their premises from any location.",
      "Prompt fault repair and troubleshooting services to minimize downtime and maintain continuous protection.",
      "Integration of cloud storage solutions for secure, off-site backup and easy access to recorded footage.",
      "Comprehensive AMC (Annual Maintenance Contracts) for hassle-free ongoing system support and peace of mind."
    ],
  },
  {
    heading: "Benefits",
    points: [
      "Continuous 24/7 monitoring to ensure the safety and security of your property and assets.",
      "Effective crime deterrence with the added benefit of reliable evidence collection when required.",
      "Seamless remote access capabilities, enabling real-time surveillance from any location at any time.",
      "Enhances employee, customer, and asset safety by providing a secure environment.",
      "Smooth integration with alarms, sensors, and other security systems for a unified protection solution.",
      "Significant reduction in dependency on physical security personnel, optimizing overall operational efficiency."
    ],
  },
  {
    heading: "Why Choose Us",
    points: [
      "A team of certified and highly trained professionals ensuring flawless installation and service delivery.",
      "Cost-effective installation packages and AMC plans designed to provide maximum value without compromising quality.",
      "A wide selection of camera types and configurations to meet diverse client needs and scenarios.",
      "Customized security solutions for residential, commercial, and industrial establishments.",
      "Rapid service response times to address issues and maintain uninterrupted security coverage.",
      "Trusted by over 500 satisfied customers, reflecting our commitment to quality, reliability, and excellence."
    ],
  },
    ],

  },

industrialpc: {
  title: "IndustrialPc",
  intro: `At Rohan Systems, we provide high-performance, reliable, and rugged Advantech Industrial PCs specifically designed for mission-critical industrial and automation applications. These systems are engineered to endure extreme temperatures, dust, vibrations, and continuous 24/7 operations, ensuring dependable performance in the most demanding environments.`,
  img: industrialPc,
  sections: [
    {
      heading: "What We Offer",
      points: [
        "Fanless Embedded PCs designed for seamless machine automation and industrial control systems.",
        "Panel PCs with high-resolution touchscreen displays for intuitive Human-Machine Interface (HMI) applications.",
        "Rackmount PCs optimized for server rooms, control centers, and centralized industrial computing.",
        "DIN-rail mountable compact systems tailored for PLC control and efficient factory floor deployment.",
        "Expandable models with multiple I/O ports, PCIe slots, and COM ports for enhanced connectivity and modular upgrades.",
        "Custom configurations for CPU, RAM, SSD, and operating systems to meet project-specific requirements.",
        "Industrial-grade motherboards built for extended lifecycle and long-term reliability.",
        "Models with waterproof and dustproof IP ratings suitable for harsh industrial environments."
      ]
    },
    {
      heading: "Where It Is Used",
      points: [
        "CNC and VMC machine control, monitoring, and data collection applications.",
        "Factory automation systems, robotics, and industrial process control.",
        "Energy management and smart grid monitoring systems.",
        "Transportation, traffic control units, and intelligent mobility solutions.",
        "Medical imaging, diagnostics, and laboratory equipment.",
        "Digital signage, kiosks, and interactive display systems.",
        "Oil & gas, mining, and remote infrastructure monitoring for challenging environments."
      ]
    },
    {
      heading: "Key Features",
      points: [
        "Rugged metal casing and fanless design for silent, reliable operation.",
        "Wide operating temperature range from -20°C to 60°C for extreme conditions.",
        "Shock and vibration resistance for safe deployment in industrial environments.",
        "Long-life components engineered for continuous, uninterrupted operation.",
        "Multiple LAN, USB, COM, and expansion ports for versatile connectivity options.",
        "BIOS-level remote management tools for monitoring and troubleshooting.",
        "Compatibility with Windows, Linux, and real-time operating systems for versatile applications."
      ]
    },
    {
      heading: "Benefits",
      points: [
        "Stable and uninterrupted performance even under harsh industrial conditions.",
        "Extended product availability, ensuring consistency for long-term projects.",
        "Lower maintenance requirements and reduced operational downtime.",
        "Compact and flexible installation options, suitable for tight spaces and control cabinets.",
        "Energy-efficient and noise-reduced operation for sustainable industrial usage.",
        "Supports custom automation software, SCADA systems, and industrial control applications."
      ]
    },
    {
      heading: "Why Choose Rohan Systems",
      points: [
        "Official supplier and certified integrator of Advantech products.",
        "Extensive experience serving factory, automotive, and industrial clients.",
        "Pre-sales consultation, site evaluation, and tailored hardware recommendations.",
        "Custom system builds and OS imaging to meet specific project needs.",
        "Comprehensive post-installation support and AMC services for industrial PCs.",
        "End-to-end solutions including hardware, software, and installation services."
      ]
    },
    {
      heading: "Add-On Services",
      points: [
        "Panel mount integration and cabinet setup for optimized industrial installation.",
        "Industrial switch and network configuration for seamless connectivity.",
        "UPS and power protection solutions for sensitive and critical operations.",
        "Installation of software including SCADA, CNC controllers, and LabVIEW.",
        "24/7 technical support and troubleshooting options for manufacturing clients."
      ]
    }
  ]
},

networkingservices: {
  title: "Networking – Design, Installation & Maintenance",
  intro: `At Rohan Systems, we provide end-to-end networking solutions tailored for businesses, educational institutions, industries, and homes. From structured cabling and secure Wi-Fi setups to server room planning, we ensure reliable, fast, and secure communication across all your devices and networks.`,
  img: netwrokingImg,
  sections: [
    {
      heading: "What We Offer",
      points: [
        "Comprehensive network design and layout planning to optimize connectivity and coverage across all areas.",
        "Installation and configuration of LAN and WAN networks for seamless communication and data transfer.",
        "Setup of Wi-Fi routers, range extenders, and access points to ensure robust wireless connectivity.",
        "Configuration of managed and unmanaged network switches for efficient traffic handling and control.",
        "Structured cabling solutions including CAT5e, CAT6, and CAT7 for organized and high-performance networks.",
        "Rack and patch panel installation for centralized, professional network management.",
        "Fiber optic cable installation and splicing for high-speed and long-distance connections.",
        "Setup of network printers, shared drives, and other collaborative resources for smooth operations."
      ]
    },
    {
      heading: "Types of Networks We Handle",
      points: [
        "Home networks designed to support multiple devices and users efficiently.",
        "Office networks tailored for teams and departmental connectivity with secure access.",
        "Industrial LAN setups for machine-to-server communication, automation, and monitoring.",
        "Wireless networks for large areas, showrooms, and event spaces with strong signal coverage.",
        "Hybrid networks integrating LAN and Wi-Fi for flexibility and reliability.",
        "VLAN configuration for data segregation, security, and traffic control.",
        "Internet load balancing and failover systems to maintain uptime and prevent service interruptions."
      ]
    },
    {
      heading: "Networking Devices We Provide",
      points: [
        "Routers, modems, and Wi-Fi access points for high-speed internet connectivity.",
        "Layer 2 and Layer 3 switches for optimized network traffic and management.",
        "Firewalls and secure gateways to protect internal networks from cyber threats.",
        "POE switches to power IP cameras, phones, and other connected devices.",
        "Network cabinets, patch panels, and accessories for organized infrastructure.",
        "NAS and file-sharing systems for centralized storage and collaboration.",
        "Load balancers and VPN appliances for redundancy, remote access, and secure communication."
      ]
    },
    {
      heading: "Key Features",
      points: [
        "High-speed, low-latency network performance for uninterrupted business operations.",
        "Secure configurations with firewalls, access control, and network segmentation.",
        "Remote access via VPN for hybrid and remote work environments.",
        "Integration of VoIP and video conferencing for modern communication needs.",
        "Scalable network designs to accommodate future growth and technology upgrades.",
        "Professional and organized cabling solutions for neat, durable, and maintainable infrastructure."
      ]
    },
    {
      heading: "Benefits",
      points: [
        "Significantly boosts work efficiency and accelerates file-sharing capabilities.",
        "Reduces network downtime, bottlenecks, and connectivity issues.",
        "Securely shares internet and internal resources across teams and departments.",
        "Organized and safe cabling ensures long-term durability and easier maintenance.",
        "Centralized monitoring and control of network devices for easier management.",
        "Supports smart IoT devices, automation, and future-ready network solutions."
      ]
    },
    {
      heading: "Why Choose Rohan Systems",
      points: [
        "Over 10 years of professional networking experience across multiple sectors.",
        "On-site network planning with detailed physical inspections for optimal layout.",
        "Use of industry-grade tools and testers to ensure high-quality installations.",
        "Expertise in both small-scale and enterprise-grade network solutions.",
        "Comprehensive AMC and support contracts for ongoing maintenance and reliability.",
        "Transparent pricing and dependable after-sales service for peace of mind."
      ]
    },
    {
      heading: "Add-On Services",
      points: [
        "Integration of servers and domain controllers into existing networks.",
        "Internet connectivity planning with multiple ISPs for redundancy and speed.",
        "Guest Wi-Fi setup with limited access for visitors or temporary use.",
        "CCTV integration with NVR and other network-enabled surveillance systems.",
        "Wireless bridging solutions for connecting multiple buildings over long distances."
      ]
    }
  ]
},

amcservices: {
  title: "AMC – Annual Maintenance Contracts for IT Systems",
  intro: `Rohan Systems provides comprehensive Annual Maintenance Contracts (AMC) designed to keep your entire IT infrastructure running smoothly, securely, and efficiently. Whether you manage a small office, school, factory, or enterprise-level IT ecosystem, our AMC services ensure timely updates, preventive care, and expert support for uninterrupted operations.`,
  img: amcImg,
  sections: [
    {
      heading: "What Our AMC Covers",
      points: [
        "Regular preventive maintenance for computers, laptops, and workstations to avoid unexpected failures.",
        "Routine software health checks, updates, and patches to ensure optimal system performance and security.",
        "Servicing, cleaning, and calibration of printers, scanners, and peripheral devices.",
        "Inspection and upkeep of network devices including routers, switches, and access points.",
        "CCTV camera systems and DVR/NVR maintenance to maintain surveillance reliability.",
        "Server maintenance and performance optimization for critical business applications.",
        "Management of antivirus software, firewalls, and cybersecurity measures to safeguard data.",
        "Regular backup solutions and monitoring of data integrity to prevent loss and downtime."
      ]
    },
    {
      heading: "Suitable For",
      points: [
        "Small to medium-sized offices requiring regular IT maintenance and support.",
        "Educational institutions with computer labs and digital classrooms.",
        "Retail shops and commercial establishments relying on IT equipment for daily operations.",
        "Factories, industries, and production units with complex IT and network setups.",
        "Remote workers and home offices seeking reliable support for devices and connectivity.",
        "Hospitals, clinics, and healthcare facilities with critical digital infrastructure."
      ]
    },
    {
      heading: "Key Benefits",
      points: [
        "Hassle-free IT management with dedicated expert support for all covered systems.",
        "Early detection of potential issues, minimizing downtime and disruption.",
        "Priority support and fast response times for urgent problems and breakdowns.",
        "Cost savings on repairs, replacements, and emergency service calls.",
        "Performance optimization through regular cleaning, updates, and system audits.",
        "Peace of mind with comprehensive backup solutions and security monitoring."
      ]
    },
    {
      heading: "AMC Types We Offer",
      points: [
        "Basic AMC – Focused on regular checkups, software updates, and preventive care.",
        "Comprehensive AMC – Includes hardware support, replacements, and full IT coverage.",
        "Custom AMC – Tailored for industry-specific systems such as CNC machines, billing systems, or educational labs.",
        "Quarterly or Monthly Maintenance Plans – Flexible schedules designed to suit your operational needs."
      ]
    },
    {
      heading: "Our Process",
      points: [
        "Initial audit of all IT assets covered under the AMC plan to understand scope and requirements.",
        "Custom plan creation with clear deliverables, timelines, and service expectations.",
        "Assignment of a dedicated technician or support team for business clients.",
        "On-site and remote support provided based on the issue severity and client preference.",
        "Documentation of all visits, maintenance actions, and performance logs for accountability.",
        "Transparent billing with no hidden charges, ensuring complete clarity and trust."
      ]
    },
    {
      heading: "Why Choose Rohan Systems",
      points: [
        "Over 10 years of trusted experience in IT maintenance and support across multiple sectors.",
        "Affordable AMC plans starting from ₹XXX per device per month for budget-friendly maintenance.",
        "Dedicated support team offering fast, reliable, and professional issue resolution.",
        "Support for all major brands, devices, and network configurations.",
        "Detailed reporting, proactive system checks, and performance monitoring.",
        "Long-standing relationships with offices, schools, factories, and enterprises, reflecting our reliability."
      ]
    },
    {
      heading: "Add-On Services",
      points: [
        "Extended warranty management and tracking for devices under AMC.",
        "Provision of spare devices during long repair periods to maintain productivity.",
        "Inventory tracking of IT hardware and peripherals covered under the AMC plan.",
        "Technical training for in-house teams to enhance IT awareness and troubleshooting skills.",
        "Remote desktop troubleshooting and support for convenient issue resolution from anywhere."
      ]
    }
  ]
},

printersservices: {
  title: "Printers – Sales, Repairs & Cartridge Services",
  intro: `At Rohan Systems, we provide comprehensive printing solutions designed for homes, businesses, educational institutions, and industrial applications. From the latest inkjet and laser printers to professional repair services and cartridge refilling, we ensure efficient, cost-effective, and high-quality printing for every requirement.`,
  img: printerImg,
  sections: [
    {
      heading: "What We Offer",
      points: [
        "Inkjet printers suitable for home, photo printing, and creative projects.",
        "Laser printers ideal for office, bulk, and high-speed printing requirements.",
        "All-in-One printers offering print, scan, and copy functionalities in a single device.",
        "Wi-Fi enabled and mobile printing models for seamless wireless and remote operations.",
        "Thermal printers designed for billing, POS systems, and retail applications.",
        "Dot matrix printers catering to industrial and heavy-duty printing needs.",
        "Large-format printers suitable for design, architecture, and engineering drawings.",
        "High-quality branded models from HP, Canon, Epson, Brother, and other trusted manufacturers."
      ]
    },
    {
      heading: "Printer Services",
      points: [
        "Complete printer installation with driver setup for hassle-free usage.",
        "Cartridge refilling, toner replacement, and maintenance for uninterrupted printing.",
        "Print head cleaning, alignment, and calibration to maintain high print quality.",
        "Resolution of paper jams, roller issues, and mechanical faults.",
        "Repair services for scanner and copier functionalities integrated in All-in-One devices.",
        "Motherboard, power supply, and component replacement for hardware issues.",
        "Setup for printer connectivity, network sharing, and office integration.",
        "Configuration of Wi-Fi and mobile printing options for modern workflows."
      ]
    },
    {
      heading: "Where It Is Used",
      points: [
        "Offices for reports, invoices, official documentation, and record-keeping.",
        "Retail shops and counters for billing, label printing, and receipts.",
        "Educational institutes for printing study materials, assignments, and forms.",
        "Designers, engineers, and architects for CAD drawings and large-format prints.",
        "Government and administrative offices for official records and correspondence.",
        "Homes for schoolwork, personal projects, and high-quality photo printing."
      ]
    },
    {
      heading: "Key Features",
      points: [
        "Fast print speeds with duplex and high-volume printing options.",
        "High-resolution printing for crisp text and detailed images.",
        "Wireless and mobile app control for convenient remote printing.",
        "Energy-efficient and eco-friendly models to reduce operating costs.",
        "Compact, space-saving designs for small office or home environments.",
        "Compatibility with Windows, Mac, and mobile operating systems for versatile use."
      ]
    },
    {
      heading: "Benefits",
      points: [
        "Saves time with quick printing and bulk print capabilities.",
        "Cost-effective operations with high-yield cartridges and energy-saving features.",
        "Enhanced document control and improved print quality.",
        "Convenience of in-house printing compared to outsourcing.",
        "Ease of maintenance with professional service support.",
        "Secure printing options including password and PIN-protected jobs."
      ]
    },
    {
      heading: "Why Choose Rohan Systems",
      points: [
        "Over a decade of trusted experience in printer sales, repairs, and servicing.",
        "Access to all major printer brands and models under one roof.",
        "Fast, affordable, and reliable repairs using genuine parts.",
        "On-site service for offices, schools, and businesses for minimal disruption.",
        "Annual Maintenance Contracts (AMC) available for ongoing support and care.",
        "Bulk sales, corporate supply, and leasing options for business needs."
      ]
    },
    {
      heading: "Add-On Services",
      points: [
        "Cartridge recycling, refilling, and eco-friendly disposal services.",
        "Maintenance and servicing for scanners and copier units.",
        "Wi-Fi printing setup, mobile printing configuration, and staff training.",
        "Custom ink tank conversions and printer enhancements.",
        "Printer leasing and flexible supply options for corporate clients."
      ]
    }
  ]
},

itaccessories: {
  title: "IT Accessories – Complete Range for Home, Office & Industry",
  intro: `At Rohan Systems, we offer a comprehensive selection of IT accessories and peripherals designed to enhance performance, connectivity, and productivity. Whether for home users, offices, educational institutes, or industrial setups, our range ensures top-quality solutions to complement your IT infrastructure.`,
  img: accessoriesImg,
  sections: [
    {
      heading: "What We Offer",
      points: [
        "Keyboards including wired, wireless, mechanical, and ergonomic designs for all user preferences.",
        "Mice options ranging from optical and gaming to wireless and vertical ergonomic models.",
        "Headsets suitable for professional call centers, gaming, and Bluetooth wireless connectivity.",
        "High-quality webcams in HD and Full HD for video conferencing, online learning, and surveillance.",
        "Power adapters, laptop chargers, UPS systems, and power strips to ensure uninterrupted operation.",
        "Cooling pads for laptops and desktops to maintain optimal performance and prevent overheating.",
        "Cables including HDMI, VGA, LAN, USB, and power cables for seamless connectivity.",
        "USB hubs, card readers, converters, and external storage options like hard drives, pen drives, and SSDs.",
        "Networking devices such as Wi-Fi routers, LAN switches, and range extenders.",
        "Laptop bags, sleeves, stands, risers, monitor arms, docking stations, and hubs for workspace optimization."
      ]
    },
    {
      heading: "Areas of Use",
      points: [
        "Home users for remote work, online learning, and entertainment setups.",
        "Offices to equip employee workstations and enhance daily productivity.",
        "Educational institutes for computer labs, e-learning platforms, and training setups.",
        "Industrial setups requiring rugged and specialized connectors and peripherals.",
        "Retail environments for billing systems, POS, and surveillance monitors.",
        "Designers, gamers, and content creators for high-performance peripherals and ergonomic setups."
      ]
    },
    {
      heading: "Key Features",
      points: [
        "Genuine branded accessories as well as compatible options available.",
        "Warranty and quality assurance on all products for reliability and peace of mind.",
        "Diverse range of designs and models catering to different requirements and preferences.",
        "Durable and reliable connectivity to ensure seamless operations.",
        "Plug & play functionality for easy setup with minimal configuration.",
        "Energy-efficient models for reduced power consumption and cost savings."
      ]
    },
    {
      heading: "Benefits",
      points: [
        "Enhances overall system performance and user comfort during extended usage.",
        "Protects primary devices by preventing excessive wear and tear.",
        "Improves efficiency and keeps workspaces organized and clutter-free.",
        "Speeds up data transfer and workflow through high-quality peripherals.",
        "Extends the life and reliability of IT devices and infrastructure.",
        "Improves user interaction and ease of use across all technology setups."
      ]
    },
    {
      heading: "Why Choose Rohan Systems",
      points: [
        "Over 10 years of experience supplying IT accessories directly to clients.",
        "Extensive stock of both standard and hard-to-find items for diverse needs.",
        "Expert guidance to help choose the right accessories for specific setups.",
        "Attractive bundle deals for bulk orders and corporate purchases.",
        "Competitive pricing without compromising on quality and reliability.",
        "One-stop solution for all IT hardware and accessory requirements."
      ]
    },
    {
      heading: "Add-On Services",
      points: [
        "On-site delivery and setup for home, office, or industrial environments.",
        "Cable management and workstation optimization for organized setups.",
        "Installation and configuration of Wi-Fi devices, routers, and network peripherals.",
        "Consultation for accessory replacement, upgrades, or enhancements.",
        "AMC coverage for accessories used in offices to ensure long-term reliability."
      ]
    }
  ]
},

software: {
  title: "Software – Genuine Licensing, Installation & Support",
  intro: `At Rohan Systems, we provide comprehensive licensed software solutions tailored for individuals, businesses, and industrial applications. From essential office productivity tools to advanced engineering, design, and enterprise software, we ensure you receive the right solution with proper installation, activation, and dedicated after-sales support.`,
  img: softwareImg,
  sections: [
    {
      heading: "Software Categories We Offer",
      points: [
        "Operating Systems: Windows 10, Windows 11, and Windows Server Editions for desktops and servers.",
        "Productivity Suites: Microsoft Office 2019, Office 2021, and Office 365 for efficient office workflows.",
        "Database Software: SQL Server, MySQL, Oracle DB for robust data management and storage solutions.",
        "Engineering & CAD Tools: CATIA, AutoCAD, SolidWorks for industrial design, modeling, and engineering applications.",
        "Antivirus & Security: Quick Heal, Kaspersky, McAfee, Norton to safeguard systems against malware and cyber threats.",
        "Design Software: Adobe Photoshop, Illustrator, CorelDRAW for creative professionals and content creators.",
        "Accounting & ERP: Tally ERP 9, Tally Prime, Busy Accounting for businesses and financial management.",
        "Cloud Applications: Google Workspace and Microsoft 365 Business for collaborative, cloud-based productivity."
      ]
    },
    {
      heading: "Where It’s Used",
      points: [
        "Corporate offices for documentation, spreadsheets, presentations, and communication.",
        "Educational institutions for labs, research, and faculty/student use.",
        "Designers, architects, and engineers for 2D/3D modeling and industrial design projects.",
        "Factories and engineering units using CAD/CAM applications for production planning and design.",
        "Retail businesses using accounting and GST-compliant billing software.",
        "Developers, IT teams, and DBAs managing databases and server-based applications."
      ]
    },
    {
      heading: "Key Features",
      points: [
        "100% genuine software with proper licensing, activation, and compliance verification.",
        "Flexible licensing options: single-user, multi-user, and volume licenses to suit all needs.",
        "Available in both cloud-based and offline versions according to client requirements.",
        "Support for installation, system migration, troubleshooting, and error resolution.",
        "Assistance with compliance and software audits to meet regulatory standards.",
        "Remote and on-site installation services for seamless deployment across environments."
      ]
    },
    {
      heading: "Benefits",
      points: [
        "Legally protected with licensed software ensuring compliance and peace of mind.",
        "Full access to product updates, patches, and official customer support.",
        "Reduces crashes, virus attacks, and compatibility issues for stable performance.",
        "Boosts productivity and operational efficiency across individuals and organizations.",
        "Safe for data management, networking, and sharing within secure environments.",
        "Ensures compliance and reliability for enterprise-grade IT systems."
      ]
    },
    {
      heading: "Why Choose Rohan Systems",
      points: [
        "Authorized reseller for multiple global software providers, ensuring genuine solutions.",
        "Expert installation and configuration services for home, office, and industrial environments.",
        "Guidance in selecting the most suitable license type and model for your needs.",
        "Support for hybrid, cloud-based, and enterprise-scale environments.",
        "Troubleshooting, training, and ongoing support for end-users and IT teams.",
        "Experience in integrating software seamlessly with existing systems and workflows."
      ]
    },
    {
      heading: "Add-On Services",
      points: [
        "License renewal management and automated reminders for hassle-free compliance.",
        "Multi-device license configuration and sharing for offices or teams.",
        "Secure backup solutions for licensed software and critical data.",
        "Custom configuration services including templates, macros, and system views.",
        "Cybersecurity audits and protection solutions for licensed software environments."
      ]
    }
  ]
}

};

export default ServiceDetailsData;
